export default function normalizeNumber(value)  {
    
    const [integer, decimals = ""] = value.toString().split(".");
    if (!decimals) return Number(integer);
    
    if (decimals[0] === "0") {
      return Number(integer);
    }
  
    return Number(Number(value).toFixed(2));
  }
